import { screenPath, screenPrefix } from '@/router/screenRoutes';

const ROUTE_CHILDREN = {
  'worker-credit-consult': ['worker-credit-new'],
  'worker-credit-contract-management': ['worker-credit-contract-management-details'],
  'fgts-consult': ['fgts-new', 'fgts-mass-consult', 'fgts-mass-consult-historic'],
  'cgv-proposals': ['cgv-proposal-details', 'cgv-update-proposal'],
  'cgv-consult': ['cgv-pre-consult-form', 'cgv-formalization'],
  'credit-card-simulator': ['credit-card-proposal'],
  'comunicacoes-list': ['comunicacoes-tracking', 'comunicacoes-create', 'comunicacoes-edit'],
};

export const ROUTE_CHILDREN_MAP = Object.fromEntries(
  Object.entries(ROUTE_CHILDREN)
    .map(([parent, children]) => [screenPath(parent), children.map(screenPrefix)]),
);
